module.exports = __webpack_public_path__ + "img/mo_grade1.1b08f77c.png";